import {IAuthAction, ProviderName} from './actions';
import {
  SIGNIN_START,
  SIGNIN_SUCCESS,
  SIGNIN_FAIL,
  FORGOT_PASSWORD_START,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
} from './constants';

const DEFAULT_PROVIDER = 'pramp';

export interface IAuthState {
  isLoading: boolean;
  apiErrors: Array<string>;
  provider: ProviderName;
  emailSent: boolean;
}

const initialState: IAuthState = {
  isLoading: false,
  apiErrors: [],
  provider: DEFAULT_PROVIDER,
  emailSent: false,
};

export default function authReducer(state: IAuthState = initialState, action: IAuthAction): IAuthState {
  const {type, errors, provider} = action;

  switch (type) {
    case SIGNIN_START:
    case FORGOT_PASSWORD_START:
      return {
        ...state,
        emailSent: false,
        isLoading: true,
        apiErrors: [],
        provider: provider || DEFAULT_PROVIDER,
      };
    case SIGNIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        emailSent: true,
      };
    case SIGNIN_FAIL:
    case FORGOT_PASSWORD_FAIL:
      return {
        ...state,
        isLoading: false,
        emailSent: false,
        apiErrors: errors,
      };

    default:
      return state;
  }
}
